import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { heroStats } from '@/mocks/homeData';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=A%20cinematic%20and%20artistic%20abstract%20composition%20with%20flowing%20curved%20gradients%20in%20warm%20deep%20reddish%20orange%20and%20dark%20charcoal%20tones%20subtle%20film%20grain%20texture%20soft%20glowing%20light%20effects%20elegant%20geometric%20shapes%20blending%20together%20movie%20theater%20inspired%20ambiance%20dark%20rich%20atmosphere&width=1920&height=1080&seq=hero-bg-1&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-verified-badge-line text-accent-500 text-sm"></i>
            <span className="text-xs text-background-50/90">官方正版视频平台 · 海量高清内容</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
            {t('hero.title')}
            <br />
            <span className="text-accent-500">{t('hero.titleHighlight')}</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
            <Link
              to="/"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-play-circle-fill mr-2"></i>
              {t('hero.cta')}
            </Link>
            <Link
              to="/category/all"
              className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all whitespace-nowrap"
            >
              {t('hero.secondary')}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-4 md:gap-8 max-w-xl mx-auto">
            {heroStats.map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-xl bg-background-50/10 backdrop-blur-sm">
                  <i className={`${stat.icon} text-accent-500 text-lg`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</div>
                <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}